import { Controller } from "@hotwired/stimulus"

// Empties a form's `field` targets once its submission succeeds. A post that redirects back
// to the same page is rendered as a Turbo morph, and a morph leaves a Cornerstone control's
// typed value alone (it lives on the element, not in an attribute the server renders), so a
// posted note would otherwise stay in its field. Wire it on the form:
//   data-controller="clear-on-submit" data-action="turbo:submit-end->clear-on-submit#clear"
// Turbo counts a redirect as success, so a post the server turns away WITH a redirect
// (an archived project, here) clears the field too; one answered with an error status
// (a 403 from a missing capability) keeps it.
export default class extends Controller {
  static targets = ["field"]

  clear(event) {
    if (!event.detail?.success) return
    this.fieldTargets.forEach((field) => { field.value = "" })
  }
}
